// ============================================
// FILE 4: /frontend/src/components/dashboard/AdPerformance.jsx
// PURPOSE: Ad statistics and performance metrics
// UPDATED: Collapsible with hamburger-style buttons
// ============================================

import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Eye, MessageSquare, TrendingUp, Trophy, ChevronDown, X } from 'lucide-react';

export default function AdPerformance({ stats = {} }) {
  console.log('🎨 [AdPerformance] Rendering with stats:', stats);
  
  const [isExpanded, setIsExpanded] = useState(false);

  const metrics = [
    {
      icon: Eye,
      label: 'Total Views',
      value: (stats.totalViews || 0).toLocaleString(),
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      icon: MessageSquare,
      label: 'Inquiries',
      value: stats.totalInquiries || 0,
      color: 'bg-green-500 hover:bg-green-600'
    },
    {
      icon: Trophy,
      label: 'Featured',
      value: stats.featuredListings || 0,
      color: 'bg-yellow-500 hover:bg-yellow-600'
    },
    {
      icon: TrendingUp,
      label: 'Active Ads',
      value: stats.totalListings || 0,
      color: 'bg-purple-500 hover:bg-purple-600'
    }
  ];

  return (
    <Card>
      {/* Clickable Header */}
      <CardHeader 
        className="p-3 sm:p-4 md:p-6 cursor-pointer hover:bg-accent/50 transition-colors relative"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm sm:text-base md:text-lg">Ad Performance</CardTitle>
          {isExpanded ? (
            <X className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
          ) : (
            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
          )}
        </div>
      </CardHeader>

      {/* Collapsible Content */}
      {isExpanded && (
        <CardContent className="p-3 sm:p-4 md:p-6 pt-0">
          <div className="flex flex-col gap-2 sm:gap-3">
            {metrics.map((metric, index) => (
              <div
                key={index}
                className={`${metric.color} text-white p-3 sm:p-4 rounded-lg transition-all hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] flex items-center gap-2 sm:gap-3`}
              >
                <metric.icon className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
                <span className="text-xs sm:text-sm font-medium truncate">{metric.label}</span>
                <span className="text-xs sm:text-sm font-bold ml-auto">{metric.value}</span>
              </div>
            ))}
          </div>
        </CardContent>
      )}
    </Card>
  );
}